import { render, staticRenderFns } from "./pointsetlist.vue?vue&type=template&id=7f6367a0&scoped=true"
import script from "./pointsetlist.vue?vue&type=script&lang=js"
export * from "./pointsetlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6367a0",
  null
  
)

export default component.exports